var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Modal", {
    staticClass: "cemetery-panel-wrapper",
    attrs: {
      show: _vm.showComponentModal,
      showContent: _vm.showContent,
      title: _vm.modalTitle,
      closeBtn: _vm.closeBtn,
      position: _vm.position,
      size: _vm.size,
      fullHeight: _vm.fullHeight,
    },
    on: { close: _vm.onCloseModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function ({}) {
          return [
            _c(
              "div",
              {
                class: [
                  { "d-flex flex-column flex-fill": _vm.fullHeight },
                  "ct-aside-control-item",
                ],
              },
              [
                _c(
                  "div",
                  {
                    class: [
                      { "d-flex flex-column flex-fill": _vm.fullHeight },
                      "ct-aside-control-body p-0",
                    ],
                  },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.componentView
                          ? _c(_vm.componentView, {
                              tag: "component",
                              attrs: {
                                value: _vm.componentData,
                                additional: _vm.componentDataAdditional,
                                params: _vm.componentParams,
                                moduleCode: _vm.moduleCode,
                                mapId: _vm.mapId,
                                panelCfg: _vm.panel,
                                parentId: _vm.idPanel,
                                baseTranslateID: _vm.componentTranslateID,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }